export const items = (state) => state.items;

export const pagination = (state) => state.pagination;

export const loading = (state) => state.loading;

export const counts = (state) => state.counts;

export const filters = (state) => state.filters;

export const details = (state) => state.details;

export const detailsLoading = (state) => state.detailsLoading;

export const carriers = (state) => state.carriers;

export const carriersPagination = (state) => state.carriersPagination;

export const carriersLoading = (state) => state.carriersLoading;

export const routes = (state) => state.routes;

export const routesLoading = (state) => state.routesLoading;
